export default __webpack_public_path__ + "static/media/requirements_color.8d71308f.svg";